import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../i18n/LangContext";
import Seo from "../seo/Seo";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <section className="thank_you_section">
      <Seo page="thankYou" path="/404" override={{ title: t("notFound.seoTitle"), description: t("notFound.text"), noindex: true }} />
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-md-10 text-center">
            <div className="heading_container d-flex justify-content-center">
              <h1 className="h2">{t("notFound.title")}</h1>
            </div>
            <p className="text-muted mt-4">{t("notFound.text")}</p>
            <p className="mt-5">
              <Link to="/" className="btn btn-primary px-4 py-2">{t("notFound.home")}</Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
